import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ServiceOperation } from "../../models/automation-fields";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  private projectIdSubject = new BehaviorSubject<string | null>(null);
  private pageIdSubject = new BehaviorSubject<string | null>(null);
  private automationProjectIdSubject = new BehaviorSubject<string | null>(null);
  private applicationIdSubject = new BehaviorSubject<string | null>(null);
  private automationCardTypeSubject = new BehaviorSubject<string | null>(null);
  private projectOverview = new BehaviorSubject<string | null>(null);
  private serviceIdSubject = new BehaviorSubject<string | null>(null);
  private operationIdSubject = new BehaviorSubject<string | null>(null);
  private operationSubject = new BehaviorSubject<ServiceOperation | null>(null);
  private frameworkSubject = new BehaviorSubject<string | null>(null);
  private testCaseGenerateVersionIdSubject = new BehaviorSubject<string | null>(null);
  private clearGraphSubject = new BehaviorSubject<boolean | null>(null);

  setProjectId(projectId: string): void {
    this.projectIdSubject.next(projectId);
  }

  getProjectId(): Observable<string | null> {
    return this.projectIdSubject.asObservable();
  }

  setAutomationProjectId(automationProjectId: string): void {
    this.automationProjectIdSubject.next(automationProjectId);
  }

  getAutomationProjectId(): Observable<string | null> {
    return this.automationProjectIdSubject.asObservable();
  }

  setApplicationId(applicationId: string): void {
    this.applicationIdSubject.next(applicationId);
  }

  getApplicationId(): Observable<string | null> {
    return this.applicationIdSubject.asObservable();
  }

  setPageId(pageId: string): void {
    this.pageIdSubject.next(pageId);
  }

  getPageId(): Observable<string | null> {
    return this.pageIdSubject.asObservable();
  }

  setAutomationCardType(type: string): void {
    this.automationCardTypeSubject.next(type);
  }

  getAutomationCardType(): Observable<string | null> {
    return this.automationCardTypeSubject.asObservable();
  }

  setProjectOverview(type: any): void {
    this.projectOverview.next(type);
  }

  getProjectOverview(): Observable<string | null> {
    return this.projectOverview.asObservable();
  }

  setServiceId(serviceId: string): void {
    this.serviceIdSubject.next(serviceId);
  }

  getServiceId(): Observable<string | null> {
    return this.serviceIdSubject.asObservable();
  }

  setOperationId(opId: string): void {
    this.operationIdSubject.next(opId);
  }

  getOperationId(): Observable<string | null> {
    return this.operationIdSubject.asObservable();
  }

  setOperation(operation: ServiceOperation): void {
    this.operationSubject.next(operation);
  }

  getOperation(): Observable<ServiceOperation | null> {
    return this.operationSubject.asObservable();
  }

  getFrameworkType(): Observable<string | null> {
    return this.frameworkSubject.asObservable();
  }

  setFrameworkType(type: string): void {
    this.frameworkSubject.next(type);
  }

  getTestCaseGenerateVersionId(): Observable<string | null> {
    return this.testCaseGenerateVersionIdSubject.asObservable();
  }

  setTestCaseGenerateVersionId(id: string): void {
    this.testCaseGenerateVersionIdSubject.next(id);
  }

  clearTestCaseVersionId() {
    this.testCaseGenerateVersionIdSubject.next('');
  }

  /**
   * Resets all automation-context BehaviorSubjects to null so that stale
   * Project A ids are not replayed to Project B subscribers.
   * Called by ProjectComponent on every route-param change.
   */
  clearAutomationContext(): void {
    this.automationProjectIdSubject.next(null);
    this.applicationIdSubject.next(null);
    this.pageIdSubject.next(null);
    this.serviceIdSubject.next(null);
    this.operationIdSubject.next(null);
    this.operationSubject.next(null);
    this.frameworkSubject.next(null);
    this.automationCardTypeSubject.next(null);
    this.clearTestCaseVersionId();
  }

}
